const translation = {
  SERVICES_TITLE_H5: `Ce que j'offre`,
  SERVICES_TITLE_H2: 'Services',
  SERVICES_1: 'Développement frontal',
  SERVICES_2: 'Développement back-end',
  SERVICES_3: 'Free-lance',

  SERVICES_1_SUB_1: `Créer une application frontale en utilisant le framework de votre choix`,
  SERVICES_1_SUB_2: 'Améliorer la vitesse du site et les conversions',
  SERVICES_1_SUB_3: 'Supprimer les dépendances du développeur',
  SERVICES_1_SUB_4: 'Html, Css, Scss, React, Angular, Vue, Javascript',
  SERVICES_1_SUB_5:
    "Mettre en œuvre toute gestion de l'état: Redux, Redux saga, NGrx",
  SERVICES_1_SUB_6: 'Optimisation du code',
  SERVICES_1_SUB_7: 'Mettre en œuvre une architecture de microservices',
  SERVICES_1_SUB_8: 'Correction des bugs',

  SERVICES_2_SUB_1:
    'Créer une application dorsale en utilisant Nodejs, Nestjs and Python',
  SERVICES_2_SUB_2: 'MongoDB, MysQL',
  SERVICES_2_SUB_3: 'Amélioration de la structure du backend',
  SERVICES_2_SUB_4: 'Supprimer les dépendances du développeur',
  SERVICES_2_SUB_5: 'Rédaction de scripts pour le déploiement',
  SERVICES_2_SUB_6: 'Hébergement',
  SERVICES_2_SUB_7: 'Optimisation du code',
  SERVICES_2_SUB_8: 'Mettre en œuvre une architecture de microservices',
  SERVICES_2_SUB_9: 'Correction des bugs',

  SERVICES_3_SUB_1: 'Create Fullstack web App',
  SERVICES_3_SUB_2: 'Hébergement',
  SERVICES_3_SUB_3: 'Maintenance des applications',
  SERVICES_3_SUB_4: 'Soutien à temps plein',
  SERVICES_3_SUB_5: 'Optimisation du code',
};

export default translation;
